import { render, staticRenderFns } from "./TlsCerts.vue?vue&type=template&id=71f9b202&scoped=true"
import script from "./TlsCerts.vue?vue&type=script&lang=js"
export * from "./TlsCerts.vue?vue&type=script&lang=js"
import style0 from "./TlsCerts.vue?vue&type=style&index=0&id=71f9b202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9b202",
  null
  
)

export default component.exports